import React, { useState, useEffect, useCallback, useRef } from "react";
import { Router } from "next/router";

const AdSlot: React.FC<{
  name: string;
  adSizes?: number[][];
  className?: string;
}> = ({ name, adSizes, className }) => {
  const [hash, setHash] = useState<string>();
  const slot = useRef();

  useEffect(() => {
    setHash(`div-gpt-${Math.random().toString(36).slice(2, 7) || "failsafe"}`);
  }, []);

  useEffect(() => {
    if (hash) {
      window.googletag = window.googletag || { cmd: [] };

      const googletag = window.googletag;

      const sizes = adSizes || [
        [300, 100],
        [960, 90],
      ];

      googletag.cmd.push(function () {
        if (!slot.current) {
          slot.current = googletag
            .defineSlot(name, sizes, hash)
            .addService(googletag.pubads())
            .defineSizeMapping(
              googletag
                .sizeMapping()
                .addSize([0, 0], sizes[0])
                .addSize([1024, 300], sizes[1])
                .build(),
            );

          googletag.pubads().enableSingleRequest();
          googletag.enableServices();
        }
      });

      googletag.cmd.push(function () {
        googletag.display(hash);
      });
    }
  }, [adSizes, hash, name]);

  const refreshAd = useCallback(() => {
    const googletag = window.googletag;

    googletag.cmd.push(function () {
      googletag.pubads().refresh();
    });
  }, []);

  useEffect(() => {
    Router.events.on("routeChangeComplete", refreshAd);
    return () => Router.events.off("routeChangeComplete", refreshAd);
  }, [refreshAd]);

  return (
    <div
      css={`
        display: flex;
        justify-content: center;
      `}
    >
      <div
        id={hash}
        css={`
          min-width: 300px;
          min-height: 90px;
          margin: 40px 0;
        `}
        className={className}
      >
        <div
          css={`
            width: 100%;
            display: inline-block;
            text-align: center;
            margin-bottom: 5px;
            font-size: 8px;
            line-height: 10px;
            color: #777777;
          `}
        >
          ADVERTISEMENT
        </div>
      </div>
    </div>
  );
};

export default AdSlot;
